<div class="center">
    <span>
        &copy; 2021 SBA | Software de Control Administrativo Financiero para Presupuestos | Orión Versión 1.12
    </span>
</div>